module.exports = __webpack_public_path__ + "img/arrow_white.1ef8972b.svg";